import { BiometricIdentityVerificationRequest } from "@wingspanhq/wingspan-api-sdk";
import { WSQueryCache } from "@ws-react-query";

import { queriesBiometricIdentityVerificationRequests } from "../../../../../../v3/query/queriesBiometricIdentityVerificationRequests";
import { ContextItem, RequirementTableItemData } from "../../../../types";

export const getIdentityVerificationFromCache = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem
): BiometricIdentityVerificationRequest | undefined => {
  if (!requirement.dataSourceId) {
    return undefined;
  }

  return WSQueryCache.getQueryData<BiometricIdentityVerificationRequest>(
    queriesBiometricIdentityVerificationRequests.getBiometricIdentityVerificationRequest.getQueryKey(
      {
        biometricIdentityVerificationRequestId: requirement.dataSourceId
      }
    )
  );
};
